module.exports = __webpack_public_path__ + "img/snack.7eabe37.svg";